import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { Skill } from "../skill";
import { User } from "../user/entity";

import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import { type UserSkill } from "./entity";

export const UserSkillEntityConfig: HyperEntityConfig<UserSkill> = {
  allowApiRead: Allow.authenticated,
  allowApiCrud: Allow.authenticated,
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      user: {
        $is: await copyApiPrefilterPerRole(User),
      },
    });

    filter(Roles.All, {
      skill: {
        $is: await copyApiPrefilterPerRole(Skill),
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.User, (entity) => entity.userId === remult.user!.id);

    allow(Roles.OrganizationManagers, (entity) =>
      doesExist(
        User,
        User.hyperFilter({
          id: entity.userId,
          associations: {
            $some: {
              organizationId: remult.user!.organizationId,
            },
          },
        }),
      ),
    );
  },

  allowDeletePerRole(allow) {
    allow(Roles.User, (entity) => entity.userId === remult.user!.id);
    allow(Roles.OrganizationManagers, {
      user: {
        $is: {
          associations: {
            $some: {
              organizationId: remult.user!.organizationId,
            },
          },
        },
      },
    });
  },

  allowUpdatePerRole(allow) {
    allow(Roles.User, (entity) => entity.userId === remult.user!.id);

    allow(Roles.OrganizationManagers, {
      user: {
        $is: {
          associations: {
            $some: {
              organizationId: remult.user!.organizationId,
            },
          },
        },
      },
    });
  },

  id: {
    userId: true,
    skillId: true,
  },
};
